import React, { useState, useEffect } from "react";
// import './ExtendedWarrantyDetails.scss';
import "./CustomerPurchaseOrder.scss";
import { useLocation, useNavigate } from "react-router-dom";
// import ROUTES_NAVIGATION from '../../../../../../routes/routes';
// import axiosInstance from '../../../../../../http.common';
import Swal from "sweetalert2";
// import { showErrorAlert } from '../../../../../customComponents/CustomSweetAlert/errorsweetalert';
import axiosInstance from "../../../../services/api/API";
import * as base64 from "base-64";
import backicon from "../../../../../Assets/icons/backIcon.svg"


const CustomerPurchaseOrderDetails = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [yesModal, setYesModal] = useState(false);
  const [noModal, setNoModal] = useState(false);

  const [remark, setRemark] = useState("");
  const [actionType, setActionType] = useState("");
  const [ExtWarrantyData, setExtWarrantyData] = useState({});
  const [itemReceivedVal, setItemReceivedVal] = useState(0);

  const [statusVal, setStatusVal] = useState("");

  const location = useLocation();
  const dataValues = location?.state?.data;

  const text = dataValues?.postockinsr_id;
  const encoded = base64.encode(text);

  const Token = localStorage.getItem("authToken");

  // Fetching extended warranty details
  const fetchDepartmentEdit = async () => {
    try {
      const response = await axiosInstance.get(
        `/customer-po/customer-po-details/${encoded}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Token}`,
          },
        },
      );
      const formatData = response.data.data; // <-- use object, not array
      const itemReceived = formatData.isRecevedItem;
      const status = formatData?.status;
      // setStatusVal(status);
      setItemReceivedVal(itemReceived);

      setExtWarrantyData(formatData); // <-- set the object
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchDepartmentEdit();
  }, []);

  return (
    <>
      <div className="OnboardManagamentContainer">
        <div className="OnboardManagamentbuttonContainer">
          <div className="backbutton mt-2 mb-2">
          <img src={backicon} alt="back" onClick={() => navigate(-1)} />
            <span className="backbtntitle">
          <h4>Customer Purchase Order Details</h4>
          </span>
          </div>
        </div>
        <div className="totalvaluescontainer col-xl-6 col-lg-12 mt-2 mb-2"></div>
      </div>

      {/* Customer Details */}
      <h3 className="mt-4 mb-2">Customer Details</h3>
      <div className="detail-grid">
        <div className="details-item">
          <span className="details-label">Name</span>
          <span className="details-value">
            {ExtWarrantyData?.customerDetails?.name ?? "-"}
          </span>
        </div>
        {/* <div className="details-item">
          <span className="details-label">Email</span>
          <span className="details-value">
            {ExtWarrantyData?.customerDetails?.email ?? "-"}
          </span>
        </div> */}
        <div className="details-item">
          <span className="details-label">Mobile</span>
          <span className="details-value">
            {ExtWarrantyData?.customerDetails?.mobile ?? "-"}
          </span>
        </div>
        <div className="details-item">
          <span className="details-label">Address</span>
          <span className="details-value">
            {ExtWarrantyData?.customerDetails?.address ?? "-"}
          </span>
        </div>
        <div className="details-item">
          <span className="details-label">Pincode</span>
          <span className="details-value">
            {ExtWarrantyData?.customerDetails?.pincode ?? "-"}
          </span>
        </div>
        <div className="details-item">
          <span className="details-label">State</span>
          <span className="details-value">
            {ExtWarrantyData?.customerDetails?.state ?? "-"}
          </span>
        </div>
        <div className="details-item">
          <span className="details-label">City</span>
          <span className="details-value">
            {ExtWarrantyData?.customerDetails?.city ?? "-"}
          </span>
        </div>
        <div className="details-item">
          <span className="details-label">Country</span>
          <span className="details-value">
            {ExtWarrantyData?.customerDetails?.country ?? "-"}
          </span>
        </div>
        <div className="details-item">
          <span className="details-label">Customer Invoice</span>
          {/* <span className="details-value">
            <img
              src={ExtWarrantyData?.customerDetails?.customer_invoice ?? "-"}
              alt="customer_tally_invoice"
            />
          </span> */}
          <span className="details-value">
            {ExtWarrantyData?.customerDetails?.customer_invoice && (
              <a
                href={ExtWarrantyData.customerDetails.customer_invoice}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={ExtWarrantyData.customerDetails.customer_invoice}
                  alt="customer_tally_invoice"
                  style={{ cursor: "pointer", height:"6rem", width:"10rem" }}
                />
              </a>
            )}
          </span>
        </div>
      </div>

      {/* Dealer Details */}
      <h3 className="mt-4 mb-2">Dealer Details</h3>
      <div className="detail-grid">
        <div className="details-item">
          <span className="details-label">Name</span>
          <span className="details-value">
            {ExtWarrantyData?.dealerDetails?.name ?? "-"}
          </span>
        </div>
        <div className="details-item">
          <span className="details-label">Email</span>
          <span className="details-value">
            {ExtWarrantyData?.dealerDetails?.email ?? "-"}
          </span>
        </div>
        <div className="details-item">
          <span className="details-label">Mobile</span>
          <span className="details-value">
            {ExtWarrantyData?.dealerDetails?.mobile ?? "-"}
          </span>
        </div>
        <div className="details-item">
          <span className="details-label">Address</span>
          <span className="details-value">
            {ExtWarrantyData?.dealerDetails?.address ?? "-"}
          </span>
        </div>
        <div className="details-item">
          <span className="details-label">Pincode</span>
          <span className="details-value">
            {ExtWarrantyData?.dealerDetails?.pincode ?? "-"}
          </span>
        </div>
        <div className="details-item">
          <span className="details-label">State</span>
          <span className="details-value">
            {ExtWarrantyData?.dealerDetails?.state ?? "-"}
          </span>
        </div>
        <div className="details-item">
          <span className="details-label">City</span>
          <span className="details-value">
            {ExtWarrantyData?.dealerDetails?.city ?? "-"}
          </span>
        </div>
        <div className="details-item">
          <span className="details-label">Country</span>
          <span className="details-value">
            {ExtWarrantyData?.dealerDetails?.country ?? "-"}
          </span>
        </div>
      </div>

      {/* Vehicle Details Table */}
      <h3 className="mt-4 mb-2">Vehicle Details</h3>
      <div className="vehicle-details-table-wrapper">
        <table className="vehicle-details-table">
          <thead>
            <tr>
              <th>Serial No</th>
              <th>VIN No</th>
              <th>Chassis No</th>
              <th>Motor No</th>
              <th>Battery Numbers</th>
              <th>Controller No</th>
              <th>Variant Name</th>
              <th>Model Name</th>
              <th>Color Name</th>
              <th>Base Price</th>
              <th>Tax Amount</th>
              <th>Total Amount</th>
            </tr>
          </thead>
          <tbody>
            {ExtWarrantyData?.itemDetails?.map((item, idx) => (
              <tr key={idx}>
                <td>{item?.serial_no ?? "-"}</td>
                <td>{item?.vin_no ?? "-"}</td>
                <td>{item?.chassis_no ?? "-"}</td>
                <td>{item?.motor_no ?? "-"}</td>
                <td>
                  {Array.isArray(item?.battery_no)
                    ? item.battery_no.join(", ")
                    : item?.battery_no
                      ? item.battery_no
                      : "-"}
                </td>
                <td>{item?.controller_no ?? "-"}</td>
                <td>{item?.variant_name ?? "-"}</td>
                <td>{item?.model_name ?? "-"}</td>
                <td>{item?.color_name ?? "-"}</td>
                <td>{item?.baseprice ?? "-"}</td>
                <td>{item?.taxamount ?? "-"}</td>
                <td>{item?.totalamount ?? "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Finance Details */}
      <h3 className="mt-4 mb-2">Finance Details</h3>
      <div className="detail-grid">
        <div className="details-item">
          <span className="details-label">Payment Mode</span>
          <span className="details-value">
            {ExtWarrantyData?.paymentData?.payment_mode ?? "-"}
          </span>
        </div>
        <div className="details-item">
          <span className="details-label">Base Price</span>
          <span className="details-value">
            {ExtWarrantyData?.paymentData?.cost_price ?? "-"}
          </span>
        </div>
        <div className="details-item">
          <span className="details-label">Financer</span>
          <span className="details-value">
            {ExtWarrantyData?.paymentData?.finance_bank ?? "-"}
          </span>
        </div>
        <div className="details-item">
          <span className="details-label">No Of Months</span>
          <span className="details-value">
            {ExtWarrantyData?.paymentData?.no_of_month ?? "-"}
          </span>
        </div>
        <div className="details-item">
          <span className="details-label">Payment Type</span>
          <span className="details-value">
            {ExtWarrantyData?.paymentData?.payment_type ?? "-"}
          </span>
        </div>
        <div className="details-item">
          <span className="details-label">Total Amount</span>
          <span className="details-value">
            {ExtWarrantyData?.paymentData?.final_amount ?? "-"}
          </span>
        </div>
      </div>
    </>
  );
};

export default CustomerPurchaseOrderDetails;
